'use strict';

angular.module('app.resetPassword', [])
.controller('ResetPasswordCtrl', ['$scope', '$rootScope', '$http', '$stateParams', '$location', 'AuthenticationService', 'userHandler', 'ipCookie', 'localStorageService', 
    function($scope, $rootScope, $http, $stateParams, $location, AuthenticationService, userHandler, ipCookie, localStorageService){
    
        $scope.preLoaded = false;
        $scope.errorMessage = null;

        $scope.preLoadData = function(){
            var data = {
                hashString: $stateParams.param
            }

            var req = {
                url: $rootScope.apiUrl + 'precheckHashLink',
                method: 'POST',
                data: JSON.stringify(data)
            }

            $http(req).success(function(response){

            })
            .error(function(response){
                $scope.errorMessage = response.message;
                alert(response.message);
            })
        }

        if(!$scope.preLoaded){
            $scope.preLoadData();
        }

        $scope.resetPassword = function(){        
            var data = {
                hashString:     $stateParams.param,
                userEmail:      $scope.profile.email,
                newPassword:    $scope.profile.newPassword
            }

            var req = {
                url: $rootScope.apiUrl + 'resetPasswordHash',
                method: 'POST',
                data: JSON.stringify(data)
            }

            $http(req).success(function(response){
                $scope.successMessage = response.message;
                $scope.cleanHashLink();

            })
            .error(function(response){
                $scope.errorMessage = response.message;
            });
        }

        $scope.cleanHashLink = function(){
            var data = {
                hashString: $stateParams.param
            }

            var req = {
                url: $rootScope.apiUrl + 'cleanHashLink',
                method: 'POST',
                data: JSON.stringify(data)
            }

            $http(req).success(function(response){
                $scope.sendMailConfirmNewPassword();
                $scope.login();
                $scope.checkLogIn();
            })
            .error(function(response){
                $scope.errorMessage = response.message;
            });
        };

        $scope.sendMailConfirmNewPassword = function(){
            var data = {
                userEmail: $scope.profile.email
            }

            var req = {
                url: $rootScope.apiUrl + 'sendEmailConfirmNewPassword',
                method: 'POST',
                data: JSON.stringify(data)
            }

            $http(req).success(function(response){

            })
            .error(function(response){
                $scope.errorMessage = response.message;
            })
        };

        $scope.login = function () {
            $scope.dataLoading = true;
            userHandler.authenticateUser($scope.profile.email, $scope.profile.newPassword, $scope.dataLoading).then(function (data) {
                 
            }, function (data) {
                $scope.errorMessage = data ? data.message : "";
                $scope.dataLoading = false;
            })
        };

        $scope.checkLogIn = function(){
            //check if user is logged-in
            if (localStorageService.cookie.isSupported) {
                if (typeof(ipCookie("access_token_expiration")) != 'undefined') {
                    $location.path('/dashboard')
                }
            } else {
                if (!localStorageService.get('access_token_expiration')) {
                    return false;
                }
            }            
        };
}])